import { RESET_AUTHENTICATION } from "services/redux/action-types";

export function resetAuthentication() {
	return {
		type: RESET_AUTHENTICATION
	}
}
